<template>
    <div class="page geoanalise-ocorrencia-detalhes">
        <div class="columns is-variable is-12 is-flex-wrap">
            <div
                v-for="(d, i) in dataset"
                :key="i"
                class="big-number column is-3"
                ref="chartItem"
                :data-title="d.titulo"
                :data-item-id="i"
            >
                <BigNumber
                    :ref="`${d.tipo}-${d.titulo}`"
                    v-if="d && d.tipo == 'bignumber'"
                    :title="$t(d.titulo)"
                    :datacontent="d"
                    :filtro="filtro"
                    :extraInfoNoStyle="true"
                    module="GEOANALISEOCORRENCIA"
                    @update-content="updateChart($event, i)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GeoanaliseOcorrenciaService from '@/services/agro/geoanalise/GeoanaliseOcorrenciaService';
import HelperCard from '@/components/shared/HelperCard';
import BigNumber from '@/components/shared/chart/BigNumber';

export default {
    props: {
        filtro: {
            type: Object,
            default() {
                return {
                    inicio: null,
                    fim: null,
                    safras: [],
                    culturas: [],
                };
            },
        },
        dadosMapa: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    components: {
        HelperCard,
        BigNumber,
    },
    data() {
        return {
            service: new GeoanaliseOcorrenciaService(this.$http, this.$router),
            dataset: [],
            lastSize: { w: 0, h: 0 },
            isLoading: false,
            chartsAvailable: [],
            charts: [],
            curScreenSize: 1201,
            dataInicio: new Date(this.$moment().subtract(30, 'days')),
            dataFim: new Date(),
            showCharts: false,
            erroDataInicio: false,
            erroDataFim: false,
            chartTotalClientes: {},
            chartTotalOcorrencias: {},
        };
    },
    created() {
        this.isLoading = true;

        this.carregarCartoes();
    },
    watch: {
        filtro: {
            deep: true,
            handler: function () {
                this.carregarCartoes();
            },
        },
    },
    methods: {
        resize() {
            let currentSize = {
                w: document.body.clientWidth,
                h: document.body.clientHeight,
            };
            this.curScreenSize = window.innerWidth;

            if (currentSize.w != this.lastSize.w) {
                this.redrawCharts();
            }

            this.lastSize = currentSize;
        },
        redrawCharts() {
            this.$d3.selectAll('.chart-tooltip').remove();
            this.charts.forEach((c) => {
                let component = this.$refs[`${c.tipo}-${c.titulo}`];
                if (component && component[0]) {
                    component[0].redrawChart();
                }
            });
        },
        carregarCartoes() {
            if (!this.filtro.inicio) {
                this.filtro.inicio = this.dataInicio;
            }
            if (!this.filtro.fim) {
                this.filtro.fim = this.dataFim;
            }

            this.$store.commit('addLoader');
            this.service
                .getAllCharts(this.filtro)
                .then((res) => {
                    this.charts = res.content.charts;
                    this.loadAll();
                })
                .catch((e) => {
                    console.error('Erro ao carregar os cards.', e);
                    this.$root.showMessage('error', 'msg-erro-carregar-graficos');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },

        loadAll() {
            let body = document.getElementsByTagName('body')[0];
            this.dataset = [...this.charts];
            // this.mapStackChart();
            if (body.offsetWidth > 760 && body.offsetWidth < 861) {
                let line = this.dataset.filter((d) => d.tipo == 'line')[0];
                let i = this.dataset.indexOf(line);
                if (i > -1) {
                    this.dataset.splice(this.dataset.indexOf(line), 1);
                    this.dataset.push(line);
                }
            }
            // Mostrar os charts
            this.showCharts = this.dataset.length > 0;
        },

        /*  Esta função serve para poder atualizar o conteúdo do card aqui
            ao invés de alterar a prop dentro do componente dele. */
        updateChart(datacontent, index) {
            this.$set(this.dataset, index, datacontent);
        },
        mountCharts(charts) {
            this.mountChartTotalOcorrencias();
            this.mountChartTotalClientes();

            let chartList = [];
            chartList.push(this.chartTotalClientes);
            chartList.push.apply(chartList, charts);
            chartList.push(this.chartTotalOcorrencias);

            this.charts = chartList;
        },
        mountChartTotalOcorrencias() {
            let total = 0;
            this.dadosMapa.forEach((c) => {
                c.usuarios.forEach((u) => {
                    u.ocorrencias.forEach((o) => {
                        total += o.visitas.length;
                    });
                });
            });

            this.chartTotalOcorrencias = {
                compare: false,
                currency: false,
                filtros: [],
                id: 0,
                positivo: false,
                tipo: 'bignumber',
                titulo: 'chart-total-agro-visita-itens',
                unidademedida: 'Ocorrencias',
                up: false,
                value: total,
            };
        },
        mountChartTotalClientes() {
            this.chartTotalClientes = {
                compare: false,
                currency: false,
                filtros: [],
                id: 0,
                positivo: false,
                tipo: 'bignumber',
                titulo: 'chart-total-clientes',
                up: false,
                value: this.filtro.clientes.length,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    background-color: transparent;
}
</style>
